module.exports = __webpack_public_path__ + "images/home/index/mobile/values-stage-screenshot-ab1d47887df24a9e248ff0a27b3ea203.png";